<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import KitSignUpModal from "@/components/citations/partials/KitSignUpModal.vue";
import {computed, ref} from "vue";
import {getCitations} from "@/composables/citations/useCitations";
import {kitName} from "@/composables/useLocalDomains";
import {useKitSignupState} from "@/composables/useKitSignupState";

const props = defineProps({
  isGbpLocation: {
    type: Boolean,
    required: true,
  },
});

const showModal = ref(false);

const {data} = getCitations(props.isGbpLocation);

const { shouldShowBanner } = useKitSignupState();

const hasListings = computed(() => data.value && data.value.total_listings_count > 0);
const shouldDisplayBanner = computed(() => hasListings.value && shouldShowBanner.value);
</script>

<template>
  <div
    v-if="shouldDisplayBanner"
    class="tw-bg-primary-100 tw-border tw-border-primary tw-flex tw-items-center tw-px-5 tw-py-4 tw-rounded-lg"
  >
    <div class="tw-flex tw-gap-9">
      <span class="tw-text-neutral-900 tw-text-base">
        <strong>Boost your local presence</strong> – Sign up to {{ kitName }} to get listed on {{ data.total_listings_count }} {{ data.total_listings_count > 1 ? 'platforms' : 'platform' }} and fix incorrect or missing details across the web.
      </span>

      <DefaultButton
        variant="primary-light"
        class="tw-whitespace-nowrap tw-h-12"
        @click="showModal = true"
      >
        Find Out More
      </DefaultButton>
    </div>
  </div>

  <KitSignUpModal
    v-if="showModal"
    @close="showModal = false"
  />
</template>

